import React from 'react';

import { Container } from 'react-bootstrap';

function About() {

    return (
        <>
        <Container>
            <h1 className='text-center'>About</h1>
            <p>This 3 page basic website template was made with React and Bootstrap</p>
        </Container>
        </>
    );
};

export default About;